import { useContext, useState } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader, ROLE, SIZE } from 'baseui/modal';
import { Button, ButtonRow } from '@gtintel/platform-atoms';
import { PROJECT_ACTIVATED_ID } from '@gtintel/platform-constants';
import { ProjectContext } from '../../../ProjectApp/context';
const ReactivateProjectButton = () => {
  const {
    edit
  } = useContext(ProjectContext);
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  return <>
      <Modal onClose={() => setIsOpen(false)} closeable isOpen={isOpen} animate autoFocus size={SIZE.default} role={ROLE.dialog}>
        <ModalHeader>
          Are you sure you want to reactivate this project?
        </ModalHeader>
        <ModalBody>
          Reactivating it will restore NP access to the project
        </ModalBody>
        <ModalFooter>
          <ButtonRow flexPosition="flex-end">
            <Button kind="success" testId="confirm-reactivate-project-button" loading={isLoading} disabled={isLoading} onClick={() => {
            setIsLoading(true);
            edit({
              status: PROJECT_ACTIVATED_ID
            });
            setIsLoading(false);
            setIsOpen(false);
          }}>
              Reactivate Project
            </Button>
            <Button kind="secondary" testId="cancel-reactivate-project-button" onClick={() => setIsOpen(false)}>
              Cancel
            </Button>
          </ButtonRow>
        </ModalFooter>
      </Modal>
      <Button kind="success" testId="reactivate-project-button" loading={isLoading} disabled={isLoading} onClick={() => setIsOpen(true)}>
        Reactivate Project
      </Button>
    </>;
};
export default ReactivateProjectButton;